import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            准备好开始阅读了吗？
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            加入哈哈漫画网，探索海量韩国漫画资源，享受流畅的高清下拉式阅读体验
          </p>
          <Link
            to="/category/lianai"
            className="inline-flex items-center gap-2 mt-6 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 text-sm md:text-base font-semibold hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            立即开始阅读
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="relative overflow-hidden rounded-2xl bg-accent-100/50 p-6 md:p-10">
          <div className="flex flex-wrap items-center justify-center gap-6 md:gap-12">
            {[
              { icon: 'ri-smartphone-line', label: '手机阅读', desc: '随时随地' },
              { icon: 'ri-computer-line', label: '电脑阅读', desc: '大屏畅享' },
              { icon: 'ri-download-2-line', label: '离线缓存', desc: '无网也能看' },
              { icon: 'ri-notification-3-line', label: '更新提醒', desc: '绝不错过' },
              { icon: 'ri-hd-line', label: '高清画质', desc: '极致体验' },
              { icon: 'ri-emotion-happy-line', label: '完全免费', desc: '无需付费' },
            ].map((item) => (
              <div key={item.label} className="flex flex-col items-center gap-2">
                <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-2xl bg-background-50">
                  <i className={`${item.icon} text-xl md:text-2xl text-primary-500`}></i>
                </div>
                <span className="text-xs md:text-sm font-semibold text-foreground-800 whitespace-nowrap">{item.label}</span>
                <span className="text-[11px] md:text-xs text-foreground-500 whitespace-nowrap">{item.desc}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}